import { forwardRef } from "react";
import classNames from "classnames";
import { Checkbox } from "antd/lib";
import type { GetRef, CheckboxProps } from "antd/lib";
import styles from "./styles.module.scss";

type CheckBoxRef = GetRef<typeof Checkbox>;

export const AppCheckbox = forwardRef<CheckBoxRef, CheckboxProps>(
  ({ className, ...props }, ref) => {
    return <Checkbox ref={ref} className={classNames(styles.comp, className)} {...props} />;
  },
);
